import type { TLeadRepresadoDetalhes } from '@/shared/interfaces/cliente.types'
import { HttpService } from '@/shared/lib/http'

export class GetLeadRepresadoPorIdService extends HttpService {
  async execute({ id }: { id: string }) {
    return this.http.get<TLeadRepresadoDetalhes>(`api/v2/Cliente/leadRepresado/${id}`)
  }
}
